<template>
  <div :class="$t('OfficialVerification.official-class-name')">
    <page-navigate></page-navigate>
    <div class="topTip">
        <span class="tickTrack flex items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M10.0003 18L9.83042 17.9342C4.37501 15.8256 3.74414 13.0694 3.74414 11.1797V3.96232L4.23116 3.97901C8.02324 4.10813 9.63797 2.39669 9.65319 2.37999L10.0008 2L10.3479 2.37999C10.3606 2.39374 11.8909 3.98589 15.3649 3.98589C15.3649 3.98589 15.3649 3.98589 15.3654 3.98589C15.4974 3.98589 15.6324 3.98392 15.7694 3.97901L16.2564 3.96232V11.1797C16.2564 13.0694 15.6256 15.8256 10.1702 17.9342L10.0003 18ZM4.68578 4.92752V11.1797C4.68578 12.196 4.68627 14.879 10.0003 16.9896C15.3148 14.879 15.3148 12.196 15.3148 11.1797V4.92752C12.3721 4.91623 10.6788 3.86904 10.0003 3.32801C9.32131 3.86855 7.62803 4.91525 4.68578 4.92752ZM5.78256 10.3967L6.75022 9.61264L8.68651 11.0413C8.68651 11.0413 11.3602 8.2753 13.9416 6.9846L14.3103 7.39994C14.3103 7.39994 11.0838 10.0736 9.42441 13.6237L5.78256 10.3967Z"
              fill="#A52933"
            />
            <path
              d="M16.0967 4.12695L15.7754 4.13867L15.3652 4.14551C11.8409 4.14551 10.2695 2.53113 10.2305 2.48926L10.2295 2.48828L10.001 2.2373L9.77148 2.48828C9.72609 2.53779 8.06728 4.26948 4.22559 4.13867L3.9043 4.12695V11.1797C3.9043 12.1045 4.05786 13.23 4.87207 14.3828C5.68796 15.538 7.17921 16.7382 9.8877 17.7852L10 17.8281L10.1123 17.7852C12.8208 16.7383 14.312 15.5379 15.1279 14.3828C15.9421 13.23 16.0967 12.1045 16.0967 11.1797V4.12695ZM15.1553 5.08301C12.3969 5.03741 10.7435 4.09045 10 3.52637C9.25604 4.08992 7.60309 5.03646 4.8457 5.08301V11.1797C4.8457 11.6802 4.84661 12.5676 5.48633 13.5898C6.12257 14.6062 7.40433 15.7755 10 16.8164C12.5963 15.7754 13.8785 14.6063 14.5146 13.5898C15.1543 12.5676 15.1553 11.6802 15.1553 11.1797V5.08301ZM14.0615 6.87793L14.4297 7.29395L14.54 7.41797L14.4121 7.52344L14.4102 7.52441C14.4088 7.52557 14.4071 7.5279 14.4043 7.53027C14.3984 7.53522 14.3887 7.54274 14.377 7.55273C14.3535 7.57272 14.3184 7.60321 14.2734 7.64258C14.1832 7.72158 14.0522 7.8387 13.8896 7.99023C13.5638 8.29395 13.111 8.73574 12.6074 9.28809C11.5991 10.394 10.3896 11.9367 9.56934 13.6914L9.47852 13.8857L9.31836 13.7432L5.67676 10.5166L5.53516 10.3916L5.68164 10.2725L6.64941 9.48828L6.74609 9.41016L6.84473 9.48438L8.66992 10.8301C8.6773 10.8227 8.6852 10.8148 8.69336 10.8066C8.7722 10.7278 8.8879 10.6141 9.03418 10.4736C9.32672 10.1927 9.74329 9.80445 10.2412 9.37598C11.2356 8.5203 12.5618 7.49599 13.8701 6.8418L13.9795 6.78613L14.0615 6.87793ZM13.9053 7.18457C12.6672 7.82288 11.4099 8.79237 10.4502 9.61816C9.95752 10.0421 9.54518 10.4262 9.25586 10.7041C9.11127 10.843 8.99738 10.9557 8.91992 11.0332L8.80859 11.1445C8.80634 11.1468 8.80493 11.1491 8.80371 11.1504L8.80176 11.1523L8.7041 11.2529L6.75488 9.81445L6.0293 10.4023L9.37207 13.3633C10.2076 11.6486 11.388 10.1505 12.3711 9.07227C12.8815 8.51248 13.3399 8.06438 13.6709 7.75586C13.8364 7.60156 13.9709 7.48242 14.0635 7.40137C14.0701 7.39557 14.0758 7.38919 14.082 7.38379L13.9053 7.18457ZM15.4746 11.1797C15.4746 11.6954 15.4749 12.6579 14.7861 13.7588C14.0984 14.8578 12.7377 16.0751 10.0596 17.1387L10 17.1621L9.94141 17.1387C7.26351 16.0751 5.90261 14.8578 5.21484 13.7588C4.52594 12.6579 4.52539 11.6954 4.52539 11.1797V4.76855L4.68555 4.76758C7.58615 4.75538 9.24522 3.72461 9.90039 3.20312L10 3.12305L10.0996 3.20312C10.7541 3.72497 12.4137 4.75644 15.3154 4.76758L15.4746 4.76855V11.1797ZM16.416 11.1797C16.416 12.1445 16.2547 13.3425 15.3896 14.5674C14.5262 15.7898 12.974 17.0214 10.2275 18.083L10 18.1719L9.77246 18.083C7.02605 17.0214 5.47369 15.7898 4.61035 14.5674C3.74532 13.3426 3.58398 12.1445 3.58398 11.1797V3.79688L3.75 3.80273L4.23633 3.81934C7.94519 3.94562 9.52183 2.28629 9.53516 2.27246L9.88281 1.8916L10.001 1.7627L10.1191 1.89258L10.4648 2.27148L10.5322 2.33496C10.8457 2.61679 12.2657 3.74128 15.0498 3.82129L15.3652 3.82617C15.4957 3.82617 15.6289 3.82417 15.7637 3.81934L16.251 3.80273L16.416 3.79688V11.1797Z"
              fill="#A52933"
            />
          </svg>
          <span class="tickWord word6">
            <span>防诈提醒</span>: <span>请核实 EBC官方网站 与 官方渠道信息，避免受骗风险</span>
          </span>
        </span>
      </div>
      <section class="container1 ov-hero">
        <div class="ov-hero__inner contentBox">
          <div class="ov-hero__copy">
            <h1 class="super_large-72_bold md-title-32_bold word1">
              <span class="redWord">EBC官方</span>验证中心
            </h1>
            <h2 class="subtitle-20_regular md-body-16_regular word3">
              为保障您的资金与信息安全，避免误入仿冒网站，您可以粘贴可疑链接，快速核验是否为
              EBC 官方渠道。
            </h2>
          </div>
          <div class="ov-hero__form">
            <div class="inputBox flex items-center">
              <input
                class="body-14_regular md-footnote-regular_12"
                type="text"
                name="url"
                id="url"
                placeholder="粘贴可疑网址链接"
                v-model="url" 
              />
              <button id="verification" class="primary-default_large word5" @click="verifyUrl">
                立即核验网址
              </button>
            </div>
          </div>
        </div>
      </section>

      <section class="ov-section2">
        <div class="ov-section2__bg" aria-hidden="true"></div>
        <div class="contentBox ov-section2__inner">
          <div class="ov-s2-block">
            <h2 class="title-40_bold md-title-24_bold text-center scroll-fade-up">
              常见欺诈行为
            </h2>
            <div class="ov-fraud">
              <div class="ov-fraud__grid scroll-fade-up">
                <div class="ov-fraud-card">
                  <img
                    class="ov-fraud-card__icon"
                    src="@/assets/image/OfficialVerification/section2Logo1.png"
                    alt=""
                  />
                  <div class="ov-fraud-card__content">
                    <div
                      class="ov-fraud-card__title title-24_medium md-subtitle-20_medium"
                    >
                      拉群诱导
                    </div>
                    <div
                      class="ov-fraud-card__desc body-14_regular md-body-14_regular"
                    >
                      借“服务”名义拉群，通过“专家指导”诱导用刷单赚手续费，榨干资金后平台失联、网站关闭。
                    </div>
                  </div>
                </div>

                <div class="ov-fraud-card">
                  <img
                    class="ov-fraud-card__icon"
                    src="@/assets/image/OfficialVerification/section2Logo2.png"
                    alt=""
                  />
                  <div class="ov-fraud-card__content">
                    <div
                      class="ov-fraud-card__title title-24_medium md-subtitle-20_medium"
                    >
                      虚假链接
                    </div>
                    <div
                      class="ov-fraud-card__desc body-14_regular md-body-14_regular"
                    >
                      塑造“导师”人设，引导下载仿冒APP或点击钓鱼网址，以“返利、福利”为由诱骗入金。
                    </div>
                  </div>
                </div>

                <div class="ov-fraud-card ov-fraud-card--hover-logo">
                  <div class="ov-fraud-card__iconWrap">
                    <img
                      class="ov-fraud-card__icon ov-fraud-card__icon--normal"
                      src="@/assets/image/OfficialVerification/section2Logo3.png"
                      alt=""
                    />
                    <img
                      class="ov-fraud-card__icon ov-fraud-card__icon--hover"
                      src="@/assets/image/OfficialVerification/section2LogoWarn.png"
                      alt=""
                    />
                  </div>
                  <div class="ov-fraud-card__content">
                    <div
                      class="ov-fraud-card__title title-24_medium md-subtitle-20_medium"
                    >
                      虚假盈利
                    </div>
                    <div
                      class="ov-fraud-card__desc body-14_regular md-body-14_regular"
                    >
                      发布伪造盈利截图诱导入金，通过高频刷单赚取佣金，致投资者本金大幅流失。
                    </div>
                  </div>
                </div>

                <div class="ov-fraud-card">
                  <img
                    class="ov-fraud-card__icon"
                    src="@/assets/image/OfficialVerification/section2Logo4.png"
                    alt=""
                  />
                  <div class="ov-fraud-card__content">
                    <div
                      class="ov-fraud-card__title title-24_medium md-subtitle-20_medium"
                    >
                      引导私人转账
                    </div>
                    <div
                      class="ov-fraud-card__desc body-14_regular md-body-14_regular"
                    >
                      以“资金解冻、提升额度、缴纳保证金”等为由要求向私人账户转账，资金一旦转出难以追回。
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="ov-s2-block ov-s2-block--signals">
            <h2 class="title-40_bold md-title-24_bold text-center scroll-fade-up">
              识别诈骗的关键信号
            </h2>
            <div class="ov-signals">
              <div class="ov-signals__grid scroll-fade-up">
                <div class="ov-signal-card">
                  <img
                    class="ov-signal-card__icon"
                    src="@/assets/image/OfficialVerification/section2LogoWarn.png"
                    alt=""
                  />
                  <div
                    class="ov-signal-card__title title-24_medium md-subtitle-20_medium"
                  >
                    这次联系是否来得突然？
                  </div>
                  <div
                    class="ov-signal-card__desc content-14_regular md-content-14_regular"
                  >
                    如果对方通过电话、短信、私信或社交平台主动联系您（尤其是意料之外的接触），并且很快将话题转向资金、账户或投资，请先提高警惕。
                  </div>
                </div>

                <div class="ov-signal-card">
                  <img
                    class="ov-signal-card__icon"
                    src="@/assets/image/OfficialVerification/section2LogoWarn.png"
                    alt=""
                  />
                  <div
                    class="ov-signal-card__title title-24_medium md-subtitle-20_medium"
                  >
                    对方是否在催促您尽快决定？
                  </div>
                  <div
                    class="ov-signal-card__desc content-14_regular md-content-14_regular"
                  >
                    任何“马上处理”“现在就做”“错过就来不及”的说法，都是在压缩您的判断时间。
                  </div>
                </div>

                <div class="ov-signal-card">
                  <img
                    class="ov-signal-card__icon"
                    src="@/assets/image/OfficialVerification/section2LogoWarn.png"
                    alt=""
                  />
                  <div
                    class="ov-signal-card__title title-24_medium md-subtitle-20_medium"
                  >
                    对方是否在影响您的情绪？
                  </div>
                  <div
                    class="ov-signal-card__desc content-14_regular md-content-14_regular"
                  >
                    诈骗往往不会先讲逻辑，而是先制造兴奋、焦虑、害怕或稀缺感，让您在情绪里做决定。
                  </div>
                </div>

                <div class="ov-signal-card">
                  <img
                    class="ov-signal-card__icon"
                    src="@/assets/image/OfficialVerification/section2LogoWarn.png"
                    alt=""
                  />
                  <div
                    class="ov-signal-card__title title-24_medium md-subtitle-20_medium"
                  >
                    对方是否在阻止您独立核实？
                  </div>
                  <div
                    class="ov-signal-card__desc content-14_regular md-content-14_regular"
                  >
                    如果对方不希望您自己去官网核对、向第三方确认，或要求您只听从他的安排，这就是危险信号。
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="ov-section3">
        <div class="ov-s3-gridbg" aria-hidden="true"></div>
        <div class="contentBox ov-s3-inner">
          <div class="ov-s3-block">
            <h2 class="title-40_bold md-title-24_bold text-center scroll-fade-up">
              警惕冒充EBC的<span class="ov-s3-title-break"><br /></span>欺诈行为
            </h2>
            <div class="ov-s3-topCards scroll-fade-up">
              <div class="ov-s3-card ov-s3-card--dark">
                <div class="ov-s3-card__head title-24_medium md-subtitle-20_medium">
                  EBC不会：
                </div>
                <ul class="ov-s3-list content-14_regular md-content-14_regular">
                  <li>承诺保本、保证收益或稳赚不赔</li>
                  <li>私下索要银行卡密码、短信验证码</li>
                  <li>非官方链接下载软件或提交资料</li>
                  <li>以“内部消息”“老师带单”等诱导入金</li>
                  <li>以账户异常、风控审核为由要求转账解冻</li>
                </ul>
                <img
                  class="ov-s3-card__floatImg ov-s3-card__floatImg--ebc"
                  src="@/assets/image/OfficialVerification/section3Logo1.webp"
                  alt=""
                />
              </div>

              <div class="ov-s3-card ov-s3-card--light">
                <div class="ov-s3-warnTitle title-24_medium md-subtitle-20_medium">
                  近期，疑似有不法分子冒充EBC相关人员，请注意甄别，谨防诈骗
                </div>
                <div class="ov-s3-warnFoot">
                  <div class="ov-s3-warnNote content-14_regular md-body-14_regular">
                    *以下均属于高危信号
                  </div>
                  <div class="ov-s3-tags">
                    <span class="ov-s3-tag content-14_regular md-content-14_regular"
                      >稳赚不赔</span
                    >
                    <span class="ov-s3-tag content-14_regular md-content-14_regular"
                      >内部消息</span
                    >
                    <span class="ov-s3-tag content-14_regular md-content-14_regular"
                      >老师带单</span
                    >
                    <span class="ov-s3-tag content-14_regular md-content-14_regular"
                      >限时名额</span
                    >
                  </div>
                </div>
                <img
                  class="ov-s3-card__floatImg ov-s3-card__floatImg--warn"
                  src="@/assets/image/OfficialVerification/section3Logo2.webp"
                  alt=""
                />
              </div>
            </div>
          </div>

          <div class="ov-s3-block">
            <h2 class="title-40_bold md-title-24_bold text-center scroll-fade-up">如何保护自身安全</h2>
            <div class="ov-s3-safetyCard scroll-fade-up">
              <div class="ov-s3-safetyGroup">
                <div class="ov-s3-safetyTitle title-24_medium md-subtitle-20_medium">
                  建议这样做
                </div>
                <div class="ov-s3-chipRow">
                  <div class="ov-s3-chip">
                    <img
                      class="ov-s3-chip__icon"
                      src="@/assets/image/OfficialVerification/section3True.webp"
                      alt=""
                    />
                    <span class="content-14_regular md-content-14_regular"
                      >对所有非官方电话、邮件和短信谨慎对待</span
                    >
                  </div>
                  <div class="ov-s3-chip">
                    <img
                      class="ov-s3-chip__icon"
                      src="@/assets/image/OfficialVerification/section3True.webp"
                      alt=""
                    />
                    <span class="content-14_regular md-content-14_regular"
                      >定期检查银行账户和账单</span
                    >
                  </div>
                  <div class="ov-s3-chip">
                    <img
                      class="ov-s3-chip__icon"
                      src="@/assets/image/OfficialVerification/section3True.webp"
                      alt=""
                    />
                    <span class="content-14_regular md-content-14_regular"
                      >如果对方催促您做出决定，请保持警惕</span
                    >
                  </div>
                  <div class="ov-s3-chip">
                    <img
                      class="ov-s3-chip__icon"
                      src="@/assets/image/OfficialVerification/section3True.webp"
                      alt=""
                    />
                    <span class="content-14_regular md-content-14_regular"
                      >有任何不确定时，第一时间和官方联系并获得协助</span
                    >
                  </div>
                  <div class="ov-s3-chip">
                    <img
                      class="ov-s3-chip__icon"
                      src="@/assets/image/OfficialVerification/section3True.webp"
                      alt=""
                    />
                    <span class="content-14_regular md-content-14_regular"
                      >不要相信任何所谓“内幕消息”和“高胜率策略”</span
                    >
                  </div>
                </div>
              </div>

              <div class="ov-s3-safetyGroup">
                <div class="ov-s3-safetyTitle title-24_medium md-subtitle-20_medium">
                  不要做
                </div>
                <div class="ov-s3-chipRow">
                  <div class="ov-s3-chip">
                    <img
                      class="ov-s3-chip__icon"
                      src="@/assets/image/OfficialVerification/section3Error.webp"
                      alt=""
                    />
                    <span class="content-14_regular md-content-14_regular"
                      >轻易透露你的银行账户或信用卡信息</span
                    >
                  </div>
                  <div class="ov-s3-chip">
                    <img
                      class="ov-s3-chip__icon"
                      src="@/assets/image/OfficialVerification/section3Error.webp"
                      alt=""
                    />
                    <span class="content-14_regular md-content-14_regular"
                      >与任何人分享您的密码(包括你的社交媒体密码)</span
                    >
                  </div>
                  <div class="ov-s3-chip">
                    <img
                      class="ov-s3-chip__icon"
                      src="@/assets/image/OfficialVerification/section3Error.webp"
                      alt=""
                    />
                    <span class="content-14_regular md-content-14_regular"
                      >通过下载你不信任的软件或应用来访问你的设备</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="ov-section4">
        <div class="contentBox ov-s4-inner">
          <h2 class="title-48_bold md-title-24_bold text-center scroll-fade-up">紧急止损指南</h2>
          <div class="ov-s4-cards scroll-fade-up">
            <div class="ov-s4-card">
              <div class="ov-s4-num" aria-hidden="true">01</div>
              <img
                class="ov-s4-icon"
                src="@/assets/image/OfficialVerification/section4Logo1.webp"
                alt=""
              />
              <div class="ov-s4-title subtitle-20_medium md-subtitle-20_medium">
                立即停止交易与转账
              </div>
              <div class="ov-s4-desc content-14_regular md-content-14_regular">
                停止一切交易、转账及账户操作，切勿抱有“再交一笔提现”“补缴费用解冻”等说法
              </div>
            </div>

            <div class="ov-s4-card">
              <div class="ov-s4-num" aria-hidden="true">02</div>
              <img
                class="ov-s4-icon"
                src="@/assets/image/OfficialVerification/section4Logo2.webp"
                alt=""
              />
              <div class="ov-s4-title subtitle-20_medium md-subtitle-20_medium">
                保存所有关键证据
              </div>
              <div class="ov-s4-desc content-14_regular md-content-14_regular">
                不要删除 App，保存聊天记录、转账凭证、收款账户信息、平台页面截图及相关邮件短信
              </div>
            </div>

            <div class="ov-s4-card">
              <div class="ov-s4-num" aria-hidden="true">03</div>
              <img
                class="ov-s4-icon"
                src="@/assets/image/OfficialVerification/section4Logo3.webp"
                alt=""
              />
              <div class="ov-s4-title subtitle-20_medium md-subtitle-20_medium">
                立即联系官方与支付机构
              </div>
              <div class="ov-s4-desc content-14_regular md-content-14_regular">
                尽快通过 EBC 官方渠道联客服，并第一时间联系银行或支付机构，尝试冻结涉案账户或拦截支付订单。
              </div>
            </div>
          </div>
        </div>
      </section>

    <div class="official-result-box" v-show="isOfficialResultBoxVisible">
      <input id="messageStatus" type="hidden" v-model="messageStatus">
      <div class="official-result" v-show="isOfficialResultVisible">
        <div class="result-true" v-show="isResultTrue">
          <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
            <path
              d="M54.6331 9.36618C51.6629 6.39197 48.1346 4.03356 44.2507 2.42628C40.3668 0.819003 36.2037 -0.00550645 32.0004 6.752e-05C27.7966 -0.0085854 23.6327 0.81452 19.7484 2.42198C15.8641 4.02943 12.3362 6.38948 9.36792 9.36618C-3.12069 21.8462 -3.12069 42.1525 9.36792 54.6324C12.3364 57.609 15.8643 59.9689 19.7485 61.5764C23.6328 63.1838 27.7967 64.007 32.0004 63.9986C36.2047 64.0108 40.3697 63.1893 44.2546 61.5817C48.1394 59.974 51.6669 57.6121 54.6331 54.6324C67.1229 42.1525 67.1229 21.8461 54.6331 9.36618ZM50.9345 23.6381L29.438 46.5082C29.3373 46.6214 29.2112 46.7091 29.07 46.7642C28.9605 46.838 28.8879 46.9119 28.7402 46.9463C28.4747 47.0631 28.1884 47.125 27.8983 47.1285C27.6241 47.1196 27.3526 47.0711 27.0922 46.9845L26.8362 46.8368C26.6828 46.7647 26.5362 46.679 26.3981 46.5808L14.0917 34.4689C13.8792 34.2661 13.711 34.0216 13.5975 33.7507C13.4839 33.4798 13.4276 33.1884 13.4319 32.8947C13.4319 32.3088 13.6559 31.723 14.0559 31.3205C14.4797 30.915 15.0436 30.6887 15.6301 30.6887C16.2166 30.6887 16.7805 30.915 17.2042 31.3205L27.8282 41.7845L47.7124 20.6387C48.1268 20.227 48.6815 19.9871 49.2653 19.967C49.8491 19.9469 50.419 20.1482 50.8607 20.5304C51.0815 20.7287 51.2579 20.9715 51.3781 21.2428C51.4984 21.5141 51.5599 21.8078 51.5586 22.1046C51.5566 22.6779 51.333 23.2283 50.9346 23.6406L50.9345 23.6381Z"
              fill="#52C41A" />
          </svg>
          <p class="resultTitle real title-40_bold md-title-24_bold">
            已验证
          </p>
          <p class="tips real subtitle-20_regular md-footnote-regular_12">
            您查询的信息已通过官方验证
          </p>
          <p class="url real subtitle-20_medium md-body-14_regular">{{ resultUrl }}</p>
          <div class="buttons">
            <a href="javascript:void(0);" class="primary-default_large close" @click="resetSearch">确认</a>
            <!-- <a href="javascript:void(0);" class="report real"></a> -->
          </div>
          <p class="tips2 real"></p>
        </div>
        <div class="result-wait" v-show="isResultWait">
          <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
              <g clip-path="url(#clip0_2959_1044)">
                <path d="M54.6331 9.36618C51.6629 6.39197 48.1346 4.03356 44.2507 2.42628C40.3668 0.819003 36.2037 -0.00550645 32.0004 6.752e-05C27.7966 -0.0085854 23.6327 0.81452 19.7484 2.42198C15.8641 4.02943 12.3362 6.38948 9.36792 9.36618C-3.12069 21.8462 -3.12069 42.1525 9.36792 54.6324C12.3364 57.609 15.8643 59.9689 19.7485 61.5764C23.6328 63.1838 27.7967 64.007 32.0004 63.9986C36.2047 64.0108 40.3697 63.1893 44.2546 61.5817C48.1394 59.974 51.6669 57.6121 54.6331 54.6324C67.1229 42.1525 67.1229 21.8461 54.6331 9.36618Z" fill="#1677FF"/>
                <path d="M32 16V33.1667L20.5 44.5" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
              </g>
              <defs>
                <clipPath id="clip0_2959_1044">
                  <rect width="64" height="64" fill="white"/>
                </clipPath>
              </defs>
            </svg>
          <p class="resultTitle real title-40_bold md-title-24_bold">
            验证中
          </p>
          <p class="tips real subtitle-20_regular md-footnote-regular_12">
            您查询的信息正在验证中
          </p>
          <p class="url real subtitle-20_medium md-body-14_regular">{{ resultUrl }}</p>
          <div class="buttons">
            <a href="javascript:void(0);" class="primary-default_large close" @click="resetSearch">确认</a>
            <!-- <a href="javascript:void(0);" class="report real"></a> -->
          </div>
          <p class="tips2 real"></p>
        </div>
        <div class="result-false" v-show="!isResultTrue && !isResultWait">
          <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
            <path
              d="M32 0C14.3284 0 0 14.3284 0 32C0 49.6716 14.3284 64 32 64C49.6716 64 64 49.6716 64 32C64 14.3284 49.6716 0 32 0ZM29.7143 16.5714C29.7143 16.2575 29.9718 16 30.2857 16H33.7143C34.0282 16 34.2857 16.2575 34.2857 16.5714V36C34.2853 36.1514 34.225 36.2965 34.1179 36.4036C34.0108 36.5107 33.8657 36.571 33.7143 36.5714H30.2857C30.1343 36.571 29.9892 36.5107 29.8821 36.4036C29.775 36.2965 29.7147 36.1514 29.7143 36V16.5714ZM32 48C31.0905 47.9998 30.2183 47.6383 29.5753 46.995C28.9323 46.3518 28.5712 45.4794 28.5714 44.5699C28.5716 43.6604 28.9331 42.7882 29.5764 42.1452C30.2197 41.5022 31.092 41.1411 32.0015 41.1413C32.4519 41.1414 32.8978 41.2302 33.3138 41.4027C33.7298 41.5751 34.1078 41.8278 34.4262 42.1463C34.7446 42.4648 34.9971 42.8429 35.1693 43.259C35.3416 43.6751 35.4302 44.1211 35.4301 44.5714C35.43 45.0218 35.3412 45.4677 35.1688 45.8837C34.9963 46.2997 34.7436 46.6777 34.4251 46.9961C34.1066 47.3145 33.7285 47.567 33.3124 47.7393C32.8963 47.9115 32.4503 48.0001 32 48Z"
              fill="#FF4B4E" />
          </svg>
          <p class="resultTitle real title-40_bold md-title-24_bold">
            未验证
          </p>
          <p class="tips subtitle-20_regular md-footnote-regular_12">
            您查询的信息未经官方验证，请不要与未经验证的渠道互动
          </p>
          <p class="url subtitle-20_medium md-body-14_regular">
            <span class="txt">{{ resultUrl }}</span>
            <a href="javascript:void(0);" class="report subtitle-20_medium pcReport" @click="showReportForm">举报</a>
          </p>
          <div class="buttons">
            <a href="javascript:void(0);" class="report secondary-default_medium mReport" @click="showReportForm">举报</a>
            <a href="javascript:void(0);" class="primary-default_large close" @click="resetSearch">确认</a>
          </div>
          <p class="tips2 body-16_regular md-footnote-regular_12">
            如果您认为该信息涉嫌虚假盗用，请向我们提交举报
          </p>
        </div>
      </div>

      <div class="official-report" v-show="isOfficialReportVisible">
        <p class="title title-40_bold md-title-24_bold">举报</p>
        <div class="formContainer" style="max-height: 40vh;overflow-y: auto;padding-right:5px">
          <div class="form-box-head">
            <p class="form-label mt110">举报地址</p>
            <div class="row">
              <div class="col-md-12"><input id="report-url" name="report-url" type="text" v-model="reportUrl"
                  class="form-control"></div>
            </div>
          </div>
          <div class="form-box" v-show="isFormBoxVisible">
            <p class="form-label mt110">{{ $t('OfficialVerification.official-page3.text10') }}</p>
            <div class="row">
              <div class="col-md-12"><input id="name" name="name" type="text" v-model="name" class="form-control"
                  :placeholder="$t('OfficialVerification.official-page3.text11')"></div>
            </div>
            <p class="form-label">{{ $t('OfficialVerification.official-page3.text12') }}</p>
            <div class="row">
              <div class="col-md-12"><input id="phone-email" name="email" type="text" v-model="email"
                  class="form-control" :placeholder="$t('OfficialVerification.official-page3.text13')"></div>
            </div>
            <p class="form-label">{{ $t('OfficialVerification.official-page3.text14') }}</p>
            <div class="row">
              <div class="col-md-12"><input id="phone" name="phone" type="text" v-model="phone" class="form-control"
                  :placeholder="$t('OfficialVerification.official-page3.text15')"></div>
            </div>
            <p class="form-label">{{ $t('OfficialVerification.official-page3.text16') }}</p>
            <div class="row">
              <div class="col-md-12"><input id="message_content" name="message_content" type="text"
                  v-model="messageContent" class="form-control"
                  :placeholder="$t('OfficialVerification.official-page3.text17')"></div>
            </div>
          </div>

          <p class="form-label">{{ $t('OfficialVerification.official-page3.text18') }}</p>
          <div class="verifyContainer">
            <div class="verify-input" style="float: left;">
              <input id="verify" style="width: 100%;" type="text" v-model="code" class="form-control"
                :placeholder="$t('OfficialVerification.official-page3.text19')" required>
            </div>
            <div class="verify-code" style="float: left;">
              <div @click="refreshCode">
                <ss-code :identifyCode="identifyCode"></ss-code>
              </div>
            </div>
          </div>
        </div>

        <p class="message-tips message-open-tips body-14_medium" v-show="!isFormBoxVisible">
          <a href="javascript:void(0);" id="message" @click="toggleFormBox">点击此处留言
            <span class="iconfont icon-right" style="transform: rotate(90deg); display: inline-block"></span>
          </a>
        </p>
        <p class="message-tips message-close-tips body-14_medium" v-show="isFormBoxVisible">
          <a href="javascript:void(0);" id="message_close" @click="toggleFormBox">
            收起留言
            <span class="iconfont icon-right" style="transform: rotate(-90deg); display: inline-block"></span>
          </a>
        </p>
        <div class="buttons flex">
          <a href="javascript:void(0);" class="secondary-default_large close" @click="resetSearch">取消</a>
          <a href="javascript:void(0);" id="official-contact-submit" class="primary-default_large"
            @click="handleSubmit">提交举报</a>
        </div>
      </div>

      <div class="official-report-success" v-show="isOfficialReportSuccessVisible">
        <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
          <path
            d="M54.6331 9.36618C51.6629 6.39197 48.1346 4.03356 44.2507 2.42628C40.3668 0.819003 36.2037 -0.00550645 32.0004 6.752e-05C27.7966 -0.0085854 23.6327 0.81452 19.7484 2.42198C15.8641 4.02943 12.3362 6.38948 9.36792 9.36618C-3.12069 21.8462 -3.12069 42.1525 9.36792 54.6324C12.3364 57.609 15.8643 59.9689 19.7485 61.5764C23.6328 63.1838 27.7967 64.007 32.0004 63.9986C36.2047 64.0108 40.3697 63.1893 44.2546 61.5817C48.1394 59.974 51.6669 57.6121 54.6331 54.6324C67.1229 42.1525 67.1229 21.8461 54.6331 9.36618ZM50.9345 23.6381L29.438 46.5082C29.3373 46.6214 29.2112 46.7091 29.07 46.7642C28.9605 46.838 28.8879 46.9119 28.7402 46.9463C28.4747 47.0631 28.1884 47.125 27.8983 47.1285C27.6241 47.1196 27.3526 47.0711 27.0922 46.9845L26.8362 46.8368C26.6828 46.7647 26.5362 46.679 26.3981 46.5808L14.0917 34.4689C13.8792 34.2661 13.711 34.0216 13.5975 33.7507C13.4839 33.4798 13.4276 33.1884 13.4319 32.8947C13.4319 32.3088 13.6559 31.723 14.0559 31.3205C14.4797 30.915 15.0436 30.6887 15.6301 30.6887C16.2166 30.6887 16.7805 30.915 17.2042 31.3205L27.8282 41.7845L47.7124 20.6387C48.1268 20.227 48.6815 19.9871 49.2653 19.967C49.8491 19.9469 50.419 20.1482 50.8607 20.5304C51.0815 20.7287 51.2579 20.9715 51.3781 21.2428C51.4984 21.5141 51.5599 21.8078 51.5586 22.1046C51.5566 22.6779 51.333 23.2283 50.9346 23.6406L50.9345 23.6381Z"
            fill="#52C41A" />
        </svg>
        <p class="title-32_medium md-title-24_bold">已提交，感谢您的反馈</p>
        <a href="javascript:void(0);" class="primary-default_large close" @click="resetSearch">关闭</a>
      </div>
      
    </div>
    <page-footer></page-footer>
  </div>

</template>

<script>
import 'swiper/css/swiper.css'
import axios from 'axios'
import { mapState } from 'vuex'
import fadeAnimate from "../mixins/fadeAnimate.js";

export default {
  mixins: [fadeAnimate],
  data() {
    return {
      url: '',
      lang: this.$t('OfficialVerification.lang'),
      messageStatus: 0,
      isOfficialResultBoxVisible: false,
      isOfficialResultVisible: false,
      isResultTrue: false,
      isResultWait:false,
      resultUrl: '',
      isOfficialReportVisible: false,
      isFormBoxVisible: false,
      reportUrl: '',
      name: '',
      email: '',
      phone: '',
      messageContent: '',
      isOfficialReportSuccessVisible: false,
      code: null,
      identifyCodes: "1234567890abcdefjhijklinopqrsduvwxyz", //随机串内容,从这里随机抽几个显示验证码
      identifyCode: "", //验证码图片内容
    };
  },
  mounted() {
    // 初始化验证码
    this.identifyCode = "";
    //参数：（1）随机串内容。（2）验证码显示位数
    this.makeCode(this.identifyCodes, 4);
    document.documentElement.setAttribute('data-fitter', 'true');
    this.initPage()
  },
  methods: {
    initPage(){
         if(window.matchMedia('(max-width:996px)').matches){
    const topTip = document.querySelector('.topTip');
    const tickTrack = document.querySelector('.tickTrack');

    if (topTip && tickTrack) {
    topTip.style.display = 'flex';
    topTip.style.overflow = 'hidden';
    topTip.style.whiteSpace = 'nowrap';
    topTip.style.width = '100%'; // 确保容器有固定宽度或撑满父级
    const clonedTrack = tickTrack.cloneNode(true);
    topTip.appendChild(clonedTrack);
    const style = document.createElement('style');
    style.innerHTML = `
        .tickTrack {
        flex-shrink: 0; 
        margin-right: 60vw; 
        animation: smoothMarquee 15s linear infinite; 
        }

        @keyframes smoothMarquee {
        0% {
            transform: translateX(0);
        }
        100% {
            transform: translateX(calc(-100% - 60vw));
        }
        }
    `;
    document.head.appendChild(style);
    }
}
    },
    copyDeal(text){
        if (navigator.clipboard) {
          navigator.clipboard.writeText(text).then(() => {
            this.showAlert('复制成功')
          }).catch(err => {
            console.error('复制失败:', err);
          });
        }
    },
    // 重置验证码
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    //获取验证码的值
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        //通过循环获取字符串内随机几位
        this.identifyCode +=
          this.identifyCodes[this.randomNum(0, this.identifyCodes.length)];
      }
    },
    //随机数字：用于当角标拿字符串的值
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    verifyUrl() {
      const langMessages = {
        cn: "请输入完整网站链接",
        en: "Please enter the full website URL",
        tw: "請輸入完整網站鏈接",
        ja: "完全なウェブサイトのURLを入力してください",
        ko: "전체 웹사이트 URL을 입력하십시오",
        th: "กรุณาใส่ URL ของเว็บไซต์ให้ครบถ้วน",
        vn: "Vui lòng nhập URL đầy đủ của trang web",
        ug: "تولۇق تور بەت ئادرېسىنى كىرگۈزۈڭ",
      };

      const langMessages2 = {
        cn: "请输入有效的网站链接",
        en: "Please enter a valid website URL",
        tw: "請輸入有效的網站鏈接",
        ja: "有効なウェブサイトのリンクを入力してください",
        ko: "유효한 웹사이트 링크를 입력하십시오",
        th: "กรุณาใส่ลิงก์ของเว็บไซต์ที่ถูกต้อง",
        vn: "Vui lòng nhập liên kết hợp lệ của trang web",
        ug: "ئىناۋەتلىك تور بەت ئۇلىنىشىنى كىرگۈزۈڭ",
      };

      if (this.url === '') {
        this.showAlert(langMessages[this.lang] || "Please enter the full website URL")
        return;
      }
      if (!this.isValidDomain(this.url)) {
        this.showAlert(langMessages2[this.lang] || "Please enter a valid website URL")
        return;
      }
      this.$http('https://www.ebccfd.com/VerificationAuthenticity', {
        url: this.url,
        lang: this.lang,
      })
        .then((response) => {
          const da = response.data;
          this.showResultBox = true; // 显示结果盒子
          this.showReport = false; // 隐藏报告
          this.showReportSuccess = false; // 隐藏报告成功信息
          this.showOfficialResult = true; // 显示官方结果
          if (da.code === 1) {
            this.isOfficialResultBoxVisible = true;
            this.isOfficialResultVisible = true;
            this.isResultTrue = true;
            this.isResultWait = false;

            this.resultUrl = this.url;
            this.reportUrl = this.url;
          } else if (da.code === 2) {
            this.isOfficialResultBoxVisible = true;
            this.isOfficialResultVisible = true;
            this.isResultTrue = false;
            this.isResultWait = true;
            this.resultUrl = this.url;
            this.reportUrl = this.url;
          } 
          else {
            this.isOfficialResultBoxVisible = true;
            this.isOfficialResultVisible = true;
            this.isResultTrue = false;
            this.isResultWait = false;

            this.resultUrl = this.url;
            this.reportUrl = this.url;
          }
        })
        .catch((error) => {
          console.error('There was an error!', error);
        });
    },
    resetSearch() {
      this.url = '';
      this.isOfficialResultBoxVisible = false;
      this.isOfficialResultVisible = false;
      this.isOfficialReportVisible = false;
      this.isFormBoxVisible = false;
      this.isOfficialReportSuccessVisible = false;
    },
    showReportForm() {
      this.isOfficialReportVisible = true;
    },
    toggleFormBox() {
      this.isFormBoxVisible = !this.isFormBoxVisible;
      this.messageStatus = this.isFormBoxVisible ? 1 : 0;
    },
    setMessages() {
      const langMessages = {
        cn: {
          msg_report_url: "请输入网站地址",
          msg_name: "请输入您的称呼!",
          msg_email: "请输入您的邮箱!",
          msg_phone: "请输入您的手机号!",
          msg_verify: "请输入验证码!",
          msg_message_content: "请输入信息反馈"
        },
        en: {
          msg_report_url: "Please enter the website address",
          msg_name: "Please enter your name",
          msg_email: "Please enter your email",
          msg_phone: "Please enter your phone number",
          msg_message_content: "Please enter your feedback",
          msg_verify: "Please enter the verification code",
          msg_verify_error: "Verification code error, please re-enter"
        },
        tw: {
          "msg_report_url": "請輸入網站地址",
          "msg_name": "請輸入您的稱呼!",
          "msg_email": "請輸入您的郵箱!",
          "msg_phone": "請輸入您的手機號!",
          "msg_verify": "請輸入驗證碼!",
          "msg_message_content": "請輸入信息反饋"
        },
        ja: {
          "msg_report_url": "ウェブサイトのアドレスを入力してください",
          "msg_name": "お名前を入力してください!",
          "msg_email": "メールアドレスを入力してください!",
          "msg_phone": "電話番号を入力してください!",
          "msg_verify": "確認コードを入力してください!",
          "msg_message_content": "フィードバックを入力してください"
        },
        ko: {
          "msg_report_url": "웹사이트 주소를 입력하세요",
          "msg_name": "이름을 입력하세요!",
          "msg_email": "이메일을 입력하세요!",
          "msg_phone": "전화번호를 입력하세요!",
          "msg_verify": "인증 코드를 입력하세요!",
          "msg_message_content": "피드백을 입력하세요"
        },
        th: {
          "msg_report_url": "กรุณาใส่ที่อยู่เว็บไซต์",
          "msg_name": "กรุณาใส่ชื่อของคุณ!",
          "msg_email": "กรุณาใส่อีเมลของคุณ!",
          "msg_phone": "กรุณาใส่หมายเลขโทรศัพท์ของคุณ!",
          "msg_verify": "กรุณาใส่รหัสยืนยัน!",
          "msg_message_content": "กรุณาใส่ข้อความของคุณ"
        },
        vn: {
          "msg_report_url": "Vui lòng nhập địa chỉ trang web",
          "msg_name": "Vui lòng nhập tên của bạn!",
          "msg_email": "Vui lòng nhập email của bạn!",
          "msg_phone": "Vui lòng nhập số điện thoại của bạn!",
          "msg_verify": "Vui lòng nhập mã xác minh!",
          "msg_message_content": "Vui lòng nhập phản hồi của bạn"
        },
        ug: {
          "msg_report_url": "تور بېتى ئادىرسىنى كىرگۈزۈڭ",
          "msg_name": "ئىسمىڭىزنى كىرگۈزۈڭ!",
          "msg_email": "ئېلخەت ئادرېسىڭىزنى كىرگۈزۈڭ!",
          "msg_phone": "يانفون نومۇرىڭىزنى كىرگۈزۈڭ!",
          "msg_verify": "دەلىللەش كودىنى كىرگۈزۈڭ!",
          "msg_message_content": "پىكىر-بايانىڭىزنى كىرگۈزۈڭ"
        },
      };
      this.messages = langMessages[this.lang] || langMessages.en;
    },
    showAlert(msg) {
      const alertDiv = document.createElement('div');
      alertDiv.id = "contact-alert";
      alertDiv.style.cssText = 'font-family: siyuan; padding: 12px 20px; color: rgb(255, 255, 255); text-align: center; border-radius: 6px; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); z-index: 999999; background: rgba(0, 0, 0, 0.7); font-size: 16px; transition: -webkit-transform 0.5s ease-in 0s, opacity 0.5s ease-in 0s;';
      alertDiv.textContent = msg;
      document.body.appendChild(alertDiv);
      setTimeout(() => document.body.removeChild(alertDiv), 2500);
    },
    clearForm() {
      this.reportUrl = '';
      this.name = '';
      this.email = '';
      this.phone = '';
      this.messageContent = '';
      this.code = '';
    },
    isValidDomain(domain) {
      const regex = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/[^\s]*)?$/;
      return regex.test(domain);
    },
    async handleSubmit() {
      this.setMessages();
      const {
        msg_report_url,
        msg_name,
        msg_email,
        msg_phone,
        msg_verify,
        msg_message_content
      } = this.messages;

      if (this.reportUrl === '') {
        this.showAlert(msg_report_url);
        return;
      }

      if (this.identifyCode != this.code) {
        this.code = null
        return this.$toast(this.$t('CFooters.contact.tips4'));
      }

      if (this.messageStatus === 0) {
        try {
          this.$http('https://www.ebccfd.com/VerificationAuthenticity/Report/', {
            report_url: this.reportUrl,
            lang: this.lang,
          }).then((response) => {
            const da = response.data;
            if (da.code === 1) {
              this.isOfficialResultVisible = false
              this.isOfficialReportVisible = false;
              this.isOfficialReportSuccessVisible = true;
              this.clearForm();
              this.refreshCode();
            } else {
              this.showAlert(da.msg);
            }
          })
        } catch (error) {
          this.showAlert('Error');
        }
      } else {
        if (this.name === '') {
          this.showAlert(msg_name);
          return;
        }
        if (this.email === '') {
          this.showAlert(msg_email);
          return;
        }
        if (this.phone === '') {
          this.showAlert(msg_phone);
          return;
        }
        if (this.messageContent === '') {
          this.showAlert(msg_message_content);
          return;
        }
        try {
          this.$http('https://www.ebccfd.com/VerificationAuthenticity/ReportMessage/', {
            report_url: this.reportUrl,
            name: this.name,
            email: this.email,
            lang: this.lang,
            phone: this.phone,
            message_content: this.messageContent,
          }).then((response) => {
            const da = response.data;
            if (da.code === 1) {
              this.isOfficialResultVisible = false
              this.isOfficialReportVisible = false;
              this.isOfficialReportSuccessVisible = true;
              this.clearForm();
              this.refreshCode();
            } else {
              this.showAlert(da.msg);
            }
          })
        } catch (error) {
          this.showAlert('Error');
        }
      }
    }
  },
  destroyed() {
    document.documentElement.removeAttribute('data-fitter');
  },
}
</script>

<style scoped>
@charset "UTF-8";

a:hover{
  color:#fff;
}
.secondary-default_large:hover {
    color: var(--ebc-basecolor-active-400);
}
.transparent{
  background:#fff!important;
}
.topTip {
  position: fixed;
  top: 80px;
  width: 100vw;
  background: linear-gradient(
      0deg,
      rgba(165, 41, 51, 0.1) 0%,
      rgba(165, 41, 51, 0.1) 100%
    ),
    #fff;
  padding: 13rem 0;
  padding-left: calc((100vw - 1200rem) / 2);
  font-size: 14rem;
  line-height: 22rem;
  font-weight: 400;
  color: var(--ebc-basecolor-active-500);
  z-index:999;
}

.topTip .medium {
  font-weight: 500;
}
.topTip svg {
  margin-right: 8rem;
}

@media (min-width: 996px) {
  .topTip {
    padding-left: 0;
    padding-right: 0;
    display: flex;
    justify-content: center;
  }
  .topTip .tickTrack {
    width: 1200rem;
    justify-content: center;
    margin-inline: auto;
  }
  .mn .topTip .tickTrack {
    width: 1400rem;
  }
}
@media (min-width:996px) {
  .kr h1{
    font-size: 72rem;
    line-height: 74rem;
  }
 
  .mn h1{
    font-size: 52rem;
    line-height: 64rem;
  }
  .pt h1{
    font-size: 64rem;
    line-height: 70rem;
  }
  .jp h1{
    font-size: 55rem;
    line-height: 62rem;
  }
  .ru h1{
    font-size: 50rem;
    line-height: 66rem;
  }
  .vi h1{
    font-size: 62rem;
    line-height: 68rem;
  }
  .en h1,
  .ug h1{
    font-size: 68rem;
    line-height: 74rem;
  }
  .es .container1 .top,
  .hi .container1 .top,
  .id .container1 .top{
    margin-bottom: 20rem;
  }
  .ru .ov-section4 h2{
    font-size: 44rem;
  }
  .ov-hero {
    margin-top: 80px;
  }
}
@media screen and (max-width: 996px) {
  .jp h1{
    font-size: 60rem;
  }
   .ar h1{
    font-size: 50rem;
  }
  .mn .ov-s2-block h2,
  .id .ov-s2-block h2{
    font-size: 38rem;
  }
  .ug .ov-s2-block h2,
  .vi .ov-s2-block h2,
  .th .ov-s2-block h2,
  .jp .ov-s2-block h2{
    font-size: 41rem;
  }
  .mn .ov-s3-block h2,
  .vi .ov-s3-block h2,
  .th .ov-s3-block h2,
  .jp .ov-s3-block h2{
    font-size: 41rem
  }
  .ug .ov-section4 h2{
    font-size: 41rem;
  }
  .ru .ov-section4 h2{
    font-size: 41rem;
  }
  .topTip {
    top: 44px;
    font-size: 24rem;
    line-height: 40rem;
    padding: 16rem 0 16rem 32rem;
    overflow: hidden;
    white-space: nowrap;
  }
  .topTip svg {
    margin-right: 8rem;
    flex: 0 0 32rem;
    transform: translateY(-3rem);
  }
  .topTip svg:nth-of-type(2) {
    margin-left: 900rem;
  }
  .ar  .topTip svg {
    margin-left: 16rem;
  }

  .ar .topTip svg:nth-of-type(2){
    margin-right: 900rem;
  }
  /* .tickTrack {
    --tx:110%;
    display: inline-block;
    white-space: nowrap;
    animation: scroll-left 10s linear infinite;
  }
  .mn .tickTrack{
    --tx:200%;

  }
  .ru .tickTrack{
    --tx:190%;
  }
  .id .tickTrack,
  .th .tickTrack {
    --tx:180%;
  }
  .ug .tickTrack{
    --tx:165%;
  }
  .es .tickTrack {
    --tx:155%;
  }
  .hi .tickTrack,
  .jp .tickTrack,
  .vi .tickTrack{
    --tx:150%;
  }
  .pt .tickTrack ,
  .kr .tickTrack {
    --tx:140%;
  }
  .en .tickTrack {
    --tx:130%;
  } */
  .tickWord {
    display: inline-block;
    /* padding-right: 1rem; */
  }

  @keyframes scroll-left {
    0% {
      transform: translateX(var(--tx) );
    }
    100% {
      transform: translateX(calc(var(--tx) * -1));
    }
  }
}

.contentBox {
  max-width: 1200rem;
  margin-inline: auto;
}
.redWord {
  color: var(--ebc-basecolor-active-500);
}

.container1 {
  padding-top: calc(128rem + 80px);
}

.container1 .top .left {
  padding-top: 48rem;
  flex: 0 0 650rem;
}
.container1 .top h2 {
  margin: 24rem 0 48rem;
  color: var(--ebc-text-secondary);
}
.container1 .top .inputBox {
  border-radius: var(--ebc-corner-radius-full);
  border: 0.5px solid var(--ebc-neutral-stroke);
  background: var(--ebc-neutral-bg_b);
  padding: 4rem;
  gap: 30rem;
  padding-left: 24rem;
}
.ar .container1 .top .inputBox {
  padding-left:4rem;
  padding-right: 24rem;
}
.container1 .top .inputBox input {
  color: var(--ebc-text-tertiary);
  background: var(--ebc-neutral-bg_b);
  border: 0;
  flex: 1;
  height: 100%;
}

.container1 .top .inputBox input::placeholder {
  color: var(--ebc-text-tertiary);
}
.container1 #verification {
  min-width: 160rem;
}
.container1 .right {
  width: 418rem;
  transform:translateX(90rem);
}
@media (min-width:996px) {
  .container1 .top{
    position: relative;
  }
  .container1 .right {
    position: absolute;
    right:0;
  }
  .container1 .bottom{
    margin-top: 88rem;
  }
  .es .container1 .top .left{
    flex:0 0 660rem;
  }
  .es h1{
    font-size: 60rem;
    line-height: 66rem;
  }
  .ar .container1 .right{
    left:0;
    right: unset;
  }
}
.container1 .bottom h2 {
  margin-bottom: 24rem;
}
.container1 .bottom .tipTitle {
  color:var(--ebc-text-primary)
}
.container1 .bottom .tipDesc {
  color: var(--ebc-text-secondary);
  margin-bottom: 16rem;
}

  .container1 .bottom .tipDesc:last-child {
    margin-bottom: 0;
  }
@media (max-width: 996px) {
  .container1 {
    padding: 122rem 32rem 0;
  }
  .container1 .right{
    width: 558rem;
    height: auto;
    margin-left: 60rem;
    transform:translateX(0);
  }
  .container1 .top {
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin-bottom: 80rem;
  }
  .container1 .top .left {
    order: 2;
    position: relative;
    flex: 1;
    padding: 40rem 0 112rem;
  }
  .container1 .top h2 {
    margin: 16rem 0 80rem;
  }

  .container1 .top .left .inputBox {
    padding: 24rem 32rem;
  }
  .container1 .top .left input,
  .container1 .top .left input::placeholder {
    text-align: center;
  }
  .container1 .top #verification {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 80rem;
    font-size: 28rem;
    line-height: 44rem;
  }
  .container1 .bottom h2{
    margin-bottom: 32rem;
  }
  .container1 .bottom .tipDesc{
    margin-bottom: 24rem;
  }


}

.container1.ov-hero {
  padding: 0;
  min-height: 770rem;
  position: relative; /* 确保子元素定位 */
  color: #fff;
  overflow: hidden; /* 防止伪元素溢出 */
}
@media (min-width: 996px) {
  
 .container1.ov-hero::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1; /* 置于内容下方 */
  background-image: 
    linear-gradient(0deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.2) 100%),
    url('../assets/image/OfficialVerification/section1Bg.webp');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

/* 当处于 RTL 环境时，对背景层进行水平翻转 */
.ar .container1.ov-hero::before{
  transform: scaleX(-1);
}
}

.container1.ov-hero .redWord {
  color: #fff;
}
.ov-hero__inner {
  min-height: 770rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 45rem;
  /* padding-top: calc(80px + 88rem); */
  /* padding-bottom: 120rem; */
}
.ov-hero__copy {
  max-width: 644rem;
}
.container1.ov-hero h2 {
  margin: 24rem 0 0;
  color: rgba(255, 255, 255, 0.9);
}
.ov-hero__form {
  margin-top: 80rem;
}
.ov-hero__form .inputBox {
  /* width: 680rem; */
  display: flex;
  align-items: center;
  gap: 20rem;
  background: transparent;
  border: 0;
  padding: 0;
  backdrop-filter: none;
  border-radius: 0;
}

.ov-hero__form .inputBox input {
  width: 500rem;
  flex: none;
  height: 48rem;
  border-radius: var(--ebc-corner-radius-full);
  border: 0.5px solid var(--ebc-neutral-stroke);
  backdrop-filter: blur(4px);
  background: rgba(255, 255, 255, 0.95);
  padding: 0 24rem;
  color: rgba(0, 0, 0, 0.64);
  outline: none;
}
.ov-hero__form .inputBox input::placeholder {
  color: rgba(0, 0, 0, 0.64);
}
.container1.ov-hero #verification {
  /* width: 160rem; */
  min-width: 160rem;
  max-width: unset;
  height: 48rem;
  padding: 8rem 24rem;
  font-size: 16rem;
  line-height: 28rem;
}

.ov-section2 {
  position: relative;
  padding: 120rem 0;
  overflow: hidden;
  background: #fff;
}
.ov-section2__bg {
  position: absolute;
  right: 0;
  bottom: -146rem;
  width: 1920rem;
  height: 746rem;
  background-image: url('../assets/image/OfficialVerification/section2Bg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  pointer-events: none;
}
.ov-section2__inner {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 120rem;
}
.ov-s2-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 60rem;
}

.ov-fraud {
  width: 100%;
}
.ov-fraud__grid {
  display: flex;
  gap: 24rem;
  align-items: stretch;
  justify-content: center;
  width: 100%;
}
.ov-fraud-card {
  width: 286rem;
  min-height: 260rem;
  border-radius: 24rem;
  border: 1px solid var(--ebc-neutral-stroke);
  background: #fff;
  padding: 72rem 24rem;
  display: flex;
  flex-direction: column;
  gap: 20rem;
  align-items: center;
  justify-content: center;
  text-align: center;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}
.ov-fraud-card__icon,
.ov-fraud-card__iconWrap {
  width: 64rem;
  height: 64rem;
  flex: 0 0 64rem;
}
.ov-fraud-card__iconWrap {
  position: relative;
}
.ov-fraud-card__iconWrap .ov-fraud-card__icon {
  position: absolute;
  inset: 0;
}
.ov-fraud-card__icon--hover {
  opacity: 0;
}
.ov-fraud-card__content {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.ov-fraud-card__desc {
  color: var(--ebc-text-secondary);
  display: none;
  line-height: 24rem;
}
@media (min-width: 996px) {
  .ov-fraud-card:hover {
    background: var(--ebc-neutral-bg_b);
    border-color: transparent;
    padding: 74rem 25rem;
    justify-content: center;
    align-items: center;
    text-align: center;
    gap: 0;
  }
  .ov-fraud-card:hover .ov-fraud-card__icon,
  .ov-fraud-card:hover .ov-fraud-card__iconWrap {
    display: none;
  }
  .ov-fraud-card:hover .ov-fraud-card__content {
    gap: 13rem;
  }
  .ov-fraud-card:hover .ov-fraud-card__desc {
    display: block;
  }
}

.ov-signals {
  width: 100%;
}
.ov-signals__grid {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24rem;
}
.ov-signal-card {
  background: var(--ebc-neutral-bg_b);
  border-radius: 24rem;
  padding: 48rem 40rem;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.ov-signal-card__icon {
  width: 28rem;
  height: 28rem;
  flex: 0 0 28rem;
  margin-bottom: 20rem;
}
.ov-signal-card__title {
  margin-bottom: 12rem;
}
@media (min-width: 996px) {
 .hi .ov-signal-card__title {
  white-space: nowrap;
 }
  
}
.ov-signal-card__desc {
  color: var(--ebc-text-secondary);
  line-height: 24rem;
}

.ov-section3 {
  position: relative;
  overflow: hidden;
  padding: 120rem 0;
  background: linear-gradient(180deg, #16161a 0%, #2b2b33 100%);
  color: #fff;
}
.ov-s3-gridbg {
  position: absolute;
  right: 0;
  top: 0;
  width: 1350.8rem;
  height: 900.9rem;
  /* opacity: 0.12; */
  /* mix-blend-mode: plus-lighter; */
  background-image: url('../assets/image/OfficialVerification/section3TopRightBg.webp');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: left top;
  pointer-events: none;
}
.ov-s3-inner {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 120rem;
}
.ov-s3-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 64rem;
}
.ov-s3-title-break {
  display: none;
}

.ov-s3-topCards {
  width: 100%;
  display: flex;
  gap: 24rem;
  align-items: stretch;
}
.ov-s3-card {
  position: relative;
  border-radius: 24rem;
  padding: 48rem 40rem;
  overflow: hidden;
  flex: 1;
  min-height: 332rem;
}
.ov-s3-card--dark {
  backdrop-filter: blur(2px);
  background: linear-gradient(
    99.6283deg,
    rgba(255, 255, 255, 0.05) 0.79241%,
    rgba(255, 255, 255, 0.1) 99.506%
  );
}
.ov-s3-card--light {
  background: #fff;
  color: var(--ebc-text-primary);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 15rem;
}
.ov-s3-card__head {
  color: #fff;
}
.ov-s3-list {
  margin: 12rem 0 0;
  padding-left: 21rem;
  display: flex;
  flex-direction: column;
  gap: 12rem;
}
@media (min-width: 996px) {
.ov-s3-list {
  max-width: 65%;
}
.ar .ov-s3-card__floatImg--ebc,
.ar .ov-s3-card__floatImg--warn {
  right: unset;
  left: 40rem;
}
.ar .ov-s4-num{
  right: unset;
  left: -10rem;
}

}
.ov-s3-list li {
  list-style: disc;
  line-height: 22rem;
}
.ov-s3-card__floatImg {
  position: absolute;
  top: 0;
  right: 0;
  width: 212rem;
  height: 224rem;
  object-fit: contain;
  pointer-events: none;
}
.ov-s3-card__floatImg--ebc {
  width: 140rem;
  height: 141rem;
  top: 48rem;
  right: 40rem;
}
.ov-s3-card__floatImg--warn {
  width: 139rem;
  height: 136rem;
  top: 45rem;
  right: 40rem;
}
.ov-s3-warnTitle {
  max-width: 312rem;
}
.ov-s3-warnFoot {
  display: flex;
  flex-direction: column;
  gap: 16rem;
}
.ov-s3-warnNote {
  color: rgba(0, 0, 0, 0.64);
}
.ov-s3-tags {
  display: flex;
  gap: 12rem;
  flex-wrap: wrap;
}
.ov-s3-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4rem 20rem;
  border-radius: 999rem;
  background: rgba(165, 41, 51, 0.1);
  color: var(--ebc-basecolor-active-500);
  line-height: 24rem;
}

.ov-s3-safetyCard {
  width: 100%;
  border-radius: 24rem;
  padding: 48rem 40rem;
  backdrop-filter: blur(2px);
  background: linear-gradient(
    107.0841deg,
    rgba(255, 255, 255, 0.05) 0.79241%,
    rgba(255, 255, 255, 0.1) 99.506%
  );
  display: flex;
  flex-direction: column;
  gap: 48rem;
}
.ov-s3-safetyGroup {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20rem;
}
.ov-s3-safetyTitle {
  color: #fff;
}
.ov-s3-chipRow {
  display: flex;
  flex-wrap: wrap;
  gap: 12rem;
}
.ov-s3-chip {
  display: inline-flex;
  align-items: center;
  gap: 8rem;
  padding: 8rem 12rem;
  border-radius: 8rem;
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #fff;
  max-width: 100%;
}
.ov-s3-chip__icon {
  width: 12rem;
  height: 12rem;
  flex: 0 0 12rem;
}
.ov-s3-chip span {
  line-height: 22rem;
}

.ov-section4 {
  background: #fff;
  padding: 120rem 0;
}
.ov-s4-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 60rem;
}
.ov-s4-cards {
  width: 100%;
  display: flex;
  gap: 24rem;
  align-items: stretch;
}
.ov-s4-card {
  position: relative;
  flex: 1;
  min-width: 0;
  min-height: 342rem;
  padding: 110rem 40rem 48rem;
  border-radius: 16rem;
  background: var(--ebc-neutral-bg_b);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 14rem;
}
.ov-s4-num {
  position: absolute;
  top: 40rem;
  right: 82rem;
  transform: translateX(50%);
  font-size: 100rem;
  line-height: 73rem;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.05);
  text-align: right;
  pointer-events: none;
  user-select: none;
}
.ov-s4-icon {
  position: relative;
  left: 0;
  top: 0;
  width: 56rem;
  height: 56rem;
  object-fit: contain;
}
.ov-s4-title {
  position: relative;
  left: 0;
  top: 0;
  right: 0;
  margin-block: 14rem -6rem;
}
.ov-s4-desc {
  position: relative;
  left: 0;
  top: 0;
  right: 0;
  color: var(--ebc-text-secondary);
  line-height: 24rem;
}

@media (max-width: 996px) {
  .ov-section3 {
    padding: 160rem 0;
  }
  .ov-s3-inner {
    padding: 0 32rem;
    gap: 160rem;
  }
  .ov-s3-gridbg {
    right: -221.64rem;
    top: -96rem;
    width: 1249.648rem;
    height: 833.438rem;
  }
  .ov-s3-block {
    gap: 80rem;
  }
  .ov-s3-title-break {
    display: inline;
  }
  .ov-s3-topCards {
    flex-direction: column;
    gap: 32rem;
  }
  .ov-s3-card {
    padding: 48rem;
    min-height: auto;
    border-radius: 48rem;
  }
  .ov-s3-card__floatImg {
    position: static;
    width: 180rem;
    height: 176rem;
    margin: 0 auto 32rem;
    display: block;
  }
  .ov-s3-card__floatImg--ebc,
  .ov-s3-card__floatImg--warn {
    width: 180rem;
    height: auto;
  }
  .ov-s3-card--dark {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  .ov-s3-card--dark .ov-s3-card__floatImg--ebc {
    order: -1;
  }
  .ov-s3-card--dark .ov-s3-card__head {
    margin-bottom: 32rem;
  }
  .ov-s3-card--dark .ov-s3-list {
    margin: 0;
    align-self: stretch;
  }
  .ov-s3-list {
    padding-left: 66rem;
    gap: 16rem;
    text-align: left;
  }
  .ov-s3-list li {
    line-height: 44rem;
  }
  .ov-s3-card--light {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 48rem;
    text-align: center;
  }
  .ov-s3-card--light .ov-s3-card__floatImg--warn {
    order: -1;
  }
  .ov-s3-warnTitle {
    max-width: 546rem;
    text-align: center;
    margin-inline: auto;
  }
  .ov-s3-warnFoot {
    gap: 24rem;
    align-items: center;
  }
  .ov-s3-tags {
    gap: 8rem;
    justify-content: center;
  }
  .ov-s3-tag {
    padding: 8rem 40rem;
    line-height: 48rem;
    flex: 1 0 45%;
  }
  .ov-s3-safetyCard {
    padding: 48rem;
    gap: 96rem;
    border-radius: 48rem;
  }
  .ov-s3-chipRow {
    flex-direction: column;
    gap: 24rem;
  }
  .ov-s3-chip {
    width: 100%;
    padding: 16rem 24rem;
    border-radius: 16rem;
    align-items: flex-start;
    gap: 16rem;
  }
  .ov-s3-chip__icon {
    width: 24rem;
    height: 24rem;
    flex: 0 0 24rem;
    margin-top: 10rem;
  }
  .ov-s3-chip span {
    line-height: 44rem;
  }
.ov-s3-safetyGroup {
gap: 40rem;
}

  .ov-section4 {
    padding: 160rem 0;
  }
  .ov-s4-inner {
    padding: 0 32rem;
    gap: 80rem;
  }
  .ov-s4-cards {
    flex-direction: column;
    gap: 32rem;
  }
  .ov-s4-card {
    min-height: 530rem;
    padding: 48rem;
    border-radius: 32rem;
    display: flex;
    flex-direction: column;
    gap: 14rem;
  }
  .ov-s4-num {
    position: relative;
    top: 0;
    right: 0;
    transform: none;
    align-self: flex-end;
    font-size: 128rem;
    line-height: 94rem;
    width: 100%;
    text-align: right;
  }
  .ar .ov-s4-num {
    right: unset;
    left: 0;
    text-align: left;
  }
  
  .ov-s4-icon,
  .ov-s4-title,
  .ov-s4-desc {
    position: relative;
    left: 0;
    top: 0;
    right: 0;
  }
 
  .ov-s4-icon {
    width: 96rem;
    height: 96rem;
    margin-top: -14rem;
  }
  .ov-s4-title {
    margin-block: 14rem 2rem;
  }
  .ov-s4-desc {
    margin-top: 16rem;
    line-height: 48rem;
  }
}

.ov-declare {
  padding: 88rem 0 0;
}
.ov-declare h2 {
  margin-bottom: 24rem;
}
.ov-declare .tipTitle {
  color: var(--ebc-text-primary);
}
.ov-declare .tipDesc {
  color: var(--ebc-text-secondary);
  margin-bottom: 16rem;
}
.ov-declare .tipDesc:last-child {
  margin-bottom: 0;
}

@media (max-width: 996px) {
  .container1.ov-hero {
    min-height: 1100rem;
    margin-top: 52rem;
    background-image:
      linear-gradient(0deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.2) 100%),
      url('../assets/image/OfficialVerification/section1Bgm.webp');
     background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  }
  .ov-hero__inner {
    min-height: 1100rem;
    padding: 0 32rem;
    padding-top: 88rem;
    padding-bottom: 160rem;
    align-items: center;
    text-align: center;
  }
  .ov-hero__copy {
    max-width: 100%;
  }
  .container1.ov-hero h2 {
    margin: 24rem 0 0;
  }
  .ov-hero__form {
    margin-top: 48rem;
    width: 100%;
  }
  .ov-hero__form .inputBox {
    width: 100%;
    padding: 0;
    flex-direction: column;
    gap: 16rem;
  }
  .ov-hero__form .inputBox input {
    width: 100%;
    height: 80rem;
    padding: 0 32rem;
  }
 
  .container1.ov-hero #verification {
    width: 100%;
    height: 80rem;
    font-size: 28rem;
    line-height: 44rem;
    margin-inline: auto;
  }

  .ov-section2 {
    padding: 160rem 0;
  }
  .ov-section2__bg {
    left: auto;
    right: -156rem;
    bottom: -17rem;
    width: 1464rem;
    height: 569rem;
    background-size: cover;
  transform: translateX(0%);

  }
  .ov-section2__inner {
    padding: 0 32rem;
    gap: 160rem;
  }
  .ov-s2-block {
    gap: 80rem;
  }
  .ov-fraud__grid {
    flex-direction: column;
    gap: 32rem;
  }
  .ov-fraud-card {
    width: 100%;
    min-height: auto;
    padding: 48rem;
    flex-direction: row;
    gap: 40rem;
    align-items: flex-start;
    justify-content: flex-start;
    text-align: left;
    border-radius: 48rem;
  }
  .ar .ov-fraud-card {
    text-align: right;
  }
  .ov-fraud-card__content {
    flex: 1;
    align-items: flex-start;
    gap: 24rem;
  }
  .ov-fraud-card__icon,
  .ov-fraud-card__iconWrap {
    width: 96rem;
    height: 96rem;
    flex: 0 0 96rem;
  }
  .ov-fraud-card__desc {
    display: block;
    /* color: var(--ebc-text-primary); */
    line-height: 44rem;
  }
  .ov-signals__grid {
    grid-template-columns: 1fr;
    gap: 32rem;
  }
  .ov-signal-card {
    padding: 48rem;
    gap: 0;
    border-radius: 48rem;
  }
  .ov-signal-card__icon {
    width: 56rem;
    height: 56rem;
    flex: 0 0 56rem;
    margin-bottom: 28rem;
  }
  .ov-signal-card__title {
    margin-bottom: 24rem;
  }
  .ov-signal-card__desc {
    line-height: 48rem;
  }

  .ov-declare {
    padding: 80rem 32rem 0;
  }
  .ov-declare h2 {
    margin-bottom: 32rem;
  }
  .ov-declare .tipDesc {
    margin-bottom: 24rem;
  }
}

.container2{
  padding:120rem 0 60rem;
}
.container2 .cardList{
  margin-top: 60rem;
  gap:24rem;
  align-items: stretch;
}
.container2 .cardList .card{
  background:var(--ebc-neutral-bg_b);
  border-radius:var(--ebc-corner-radius-rc16);
  flex:1;
  gap:64rem;
  padding:24rem;
  border:0;
}
.container2 .cardList .card .left .description{
  color:var(--ebc-text-secondary);
  margin:16rem 0;
}
.container2 .cardList .card .left a{
  width:fit-content;
  display:inline-block;
}
.container2 .cardList .card .left .btn{
  border:0;
  width:fit-content;
  padding:0;
}
.container2 .cardList .card .right{
  flex:0 0 156rem;
  height:156rem;
}

.container22{
  margin-bottom: 120rem;
}
.container22 .doTitle{
  margin-bottom: 24rem;
}
.container22 .dontDo{
  margin-top: 48rem;
}
.container22 .doTip{
  font-size: 16rem;
  font-weight: 400;
  line-height: 28rem;
  color:var(--ebc-text-secondary);
  margin-bottom: 16rem;
  display: flex;
  align-items: flex-start;
}
.container22 .doTip span{
    display: inline-block ;
  }
.container22 .doTip img{
  margin-right: 8rem;
  transform: translateY(5px);
}
.container22 .doTip .medium{
  font-weight: 500;color: var(--ebc-text-primary);
}
@media (max-width: 996px) {
  .container22 {
    padding:0 32rem 160rem;
    margin-bottom: 0;
  }
  .container22 .doTip{
    font-size: 28rem;
    line-height: 48rem;
    display: flex;
    gap:16rem;
  }
  .container22 .doTip span{
    display: inline-block ;
  }
  .container22 .doTip img{
    width: 32rem;
    height: 32rem;
    transform: translateY(3px);
  }
  .container22 .doTitle{
  margin-bottom: 32rem;
}
  .container2{
    padding:160rem 32rem 80rem;
  }
  .container2 .cardList{
    flex-direction:column;
    gap:32rem;
  }
  .container2 .cardList .card{
    gap:16rem;
    padding:48rem 32rem;
    position:relative;
  }
  .container2 .cardList .card .left{
    order:2;
  }
.container2 .cardList .card .left .description{
  margin:32rem 0 0 0;
}
.container2 .cardList .card .left a{
  position:absolute;
  right:32rem;
  top:32rem;
}
}

.container3{
  padding-bottom:120rem;
}
.container3 .left{
  flex:0 0 757rem;
}
.container3 .left .description{
  color:var(--ebc-text-secondary);
  margin:24rem 0 12rem;
}
.container3 .left .email{
  border-radius:var(--ebc-corner-radius-rc04);
  background: rgba(165, 41, 51, 0.10);
  padding:4rem 8rem;
  margin-inline:8rem;
  display:inline-block;
  color:var(--ebc-basecolor-active-500);
  cursor:copy;

}
.container3 .right{
  height: 213rem;
}

@media (max-width: 996px) {
  .container3 {
    padding:0 32rem 160rem;
    
  }
  .container3 .contentBox{
    flex-direction:column;
    gap:80rem;
  }
   .container3 .left{
    flex:1;
   }
  .container3 .left h3{
    text-align:center
  }
.container3 .left .description{
  margin:80rem 0 24rem;
}
.container3 .right{
  height: 400rem;
  margin-inline:auto;
}
}
.container3 .left .contactWay{
  color:var(--ebc-text-secondary);
}
.official-search button {
  padding: 21px 34px;
  border-radius: 4px;
  border: 1px solid #000;
  background: #4d0101;
  color: #fff;
  font-size: 16px;
  font-family: auto;
  display: inline-block;
  margin-left: 3%;
}

.official-result-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 1000;
}
.official-result-box .buttons{
  margin-top: 48rem;
  gap:24rem;
}
.official-result-box .buttons a{
  flex:1;
}
.official-result-box .verifyContainer{
  display: flex;
}
.official-result-box .verify-input{
  flex:1;
}
.official-result-box .verify-code img{
  width: 160rem;
  height: 56rem;
  margin-left: 16rem;
}
.official-result {
  width: 588rem;
  padding: 40rem 24rem;
  background-color: #ffffff;
  border-radius: var(--ebc-corner-radius-rc16);
  text-align: center;
  position: absolute;
  top: 46%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.official-result svg {
  width: 63rem;
  height: 63rem;
}
.official-result .url {
  display: block;
  padding: 12rem 16rem;
  text-align: center;
  leading-trim: both;
  text-edge: cap;
  margin: 40rem 0;
  overflow: auto;
  border-radius: var(--ebc-corner-radius-rc08);
  background: var(--ebc-neutral-bg_b);
}
.official-result .url.real {
  margin:40rem 0;
  padding:12rem 0;
  border-radius: var(--ebc-corner-radius-rc08);
  background: var(--ebc-neutral-bg_b);
}
.official-result .resultTitle{
  margin:40rem 0 16rem;
}
.official-result .tips {
  color: var(--ebc-text-secondary);
  text-align: center;
  font-family: auto;
  margin: 16rem 0 40rem;
}
/* .official-result .tips.real {
  color: #66b54e;
} */

.official-result .close.real {
  width: 100%;
}
.official-result,
.official-report,
.official-report-success {
  background-image: url('../assets/image/OfficialVerification/ebcLogo.png');
}
.official-result .report {
  display: inline-block;
  color: var(--ebc-brand-accent-coral);
  leading-trim: both;
  text-edge: cap;
  float:right;  
}
.official-result .mReport{
  display:none;
}
.official-result .report.real {
  display: none;
}
.official-result .tips2 {
  color: var(--ebc-text-tertiary);
  text-align: center;
  margin-top: 24rem;
}
.official-result .tips2.real {
  display: none;
}

.official-report {
  width: 588rem;
  padding: 40rem 24rem;
  background-color: #ffffff;
  border-radius: var(--ebc-corner-radius-rc16);
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  overflow: auto;
  max-height:70vh;
}
.official-report svg {
  margin-right: 8px;
}
.official-report .title {
  text-align: center;
  leading-trim: both;
  text-edge: cap;
  margin-bottom: 48rem;
}

.official-report .contact-submit {
  display: inline-block;
  width: 47%;
  padding: 18px;
  border-radius: 4px;
  border: 1px solid #000;
  background: #4d0101;
  color: #fff;
  leading-trim: both;
  text-edge: cap;
  font-size: 14px;
  font-family: auto;
  margin-top: 40px;
  margin-left: 4%;
}
.official-report .form-label {
  color: var(--ebc-text-secondary);
  font-size: 16rem;
  font-weight: 400;
  line-height: 24rem;
  text-align: left;
  margin-top: 24rem;
  margin-bottom: 12rem;
}
.ar .official-report .form-label{
  text-align: right;
}
.official-report input:placeholder{
  color:var(--ebc-text-tertiary)
}
.official-report input {
  border: 0;
  display: flex;
  padding: 12rem 16rem;
  justify-content: center;
  align-items: center;
  gap: 16rem;
  color: var(--ebc-text-primary);
  font-family: auto;
  font-size: 20rem;
  font-weight: 400;
  line-height: 24rem;
  background:var(--ebc-neutral-bg_b);
  border-radius:var(--ebc-corner-radius-rc08);
  height: 56rem;
}
.official-report input:focus {
  box-shadow: none;
  background:var(--ebc-neutral-bg_b);
  border:0;
}
.official-report .message-tips {
  color: var(--ebc-text-secondary);
  font-family: auto;
  margin: 48rem auto; 
}
.official-report .message-tips a {
  /* text-decoration: underline; */
  color:var(--ebc-basecolor-active-500)
}
.official-report .message-close-tips a {
  color: var(--ebc-basecolor-active-500);
  width: 100%;
  display: block;
  /* text-decoration: underline; */
}

.official-report-success {
  width: 588rem;
  padding: 40rem 24rem;
  background:#fff;
  border-radius: var(--ebc-corner-radius-rc16);
  text-align: center;
  position: absolute;
  top: 46%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.official-report-success p {
  text-align: center;
  margin:40rem 0 48rem
}


.official-en-box .official1 .p1 {
  letter-spacing: 0px;
  font-size: 30px;
}

.official-en-box .official1 .p2 {
  letter-spacing: 0px;
  font-size: 16px;
  width: 66%;
  opacity: 0.8;
  line-height: 28px;
}
.official-en-box .official1 {
  height: auto;
  padding-bottom: 36px;
}

@media (max-width: 996px) {
  .official-result-box{
    z-index:999;
  }
  .official-result,
  .official-report,
  .official-report-success {
    width: 100%;
    padding: 40rem 24rem;
    position: absolute;
    top:unset;
    bottom: 0;
    left: 0;
    transform: translate(0, 0);
    overflow: auto;
    max-height:90vh;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    z-index:9999999999;
    padding:48rem;
  }
  .official-report-success{
    padding-top:160rem;
  }
  .official-result svg{
    width: 96rem;
    height: 96rem;
  }
  .official-result .resultTitle{
    margin:48rem 0 16rem;
  }
  .official-result .tips{
    margin:16rem 0 48rem;
  }
.official-result .pcReport{
  display:none;
}
.official-result .mReport{
display:flex;
float:none;
color:var(--ebc-basecolor-active-500);
font-weight: 500;
}
.official-result-box .buttons{
  display:flex;
  gap:32rem;
  margin:48rem 0 32rem;
}
.official-result-box .buttons a{
  height: 80rem;
  font-size: 28rem;
  font-weight: 500;
}
.official-result .url{
  padding:22rem 32rem;
}
.official-result .url.real{
  padding:18rem 32rem;
}
.official-report .message-tips{
  margin:48rem 0;
}
.official-report .form-label{
  margin:32rem 0 16rem;
  font-size: 24rem;
  font-weight: 400;
  line-height: 40rem;
}
.official-report input{
  font-size: 28rem;
  line-height: 44rem;
  padding:22rem 32rem;
  height: 80rem;
  border-radius:var(--ebc-corner-radius-rc16);
}
.official-result-box .verify-code img{
  width: 228rem;
  height: 80rem;
  margin-left: 32rem;
}
.official-result-box .verify-input{
  width: 390rem;
}
.official-report-success p{
  margin:48rem 0 216rem;
}
.official-report-success a{
  height:80rem;
  font-size: 28rem;
  font-weight: 500;
}
}
::v-deep #s-canvas{
  width: 120rem;
}
.verify-code {
  flex: 0 0 140rem
}

@media  (max-width: 996px) {
  ::v-deep #s-canvas{
  width: 165rem;
}
.verify-code {
  flex: 0 0 180rem
}
}
</style>
